import { Lock } from "lucide-react";
import { useTranslation } from "@/i18n/I18nProvider";

export interface OffersLockedPanelProps {
  /** Localized city label, e.g. "Cluj-Napoca" — interpolated into the body. */
  cityLabel: string;
  /** Deep-links into the account sidebar's sign-up view. */
  onSignUp: () => void;
}

/**
 * What a guest sees on the Offers & Events tab: the aggregated offers view
 * lives behind a (free) account. Individual offers stay visible on venue
 * cards and detail pages — the copy says "all in one place", not "hidden",
 * so the claim stays truthful. Styled like the feed's other empty-state cards.
 */
export function OffersLockedPanel({ cityLabel, onSignUp }: OffersLockedPanelProps) {
  const { t } = useTranslation();
  return (
    <div className="mt-10 rounded-2xl border border-dashed border-white/15 light:border-black/15 bg-zinc-900/30 light:bg-white/50 p-10 text-center">
      <div className="mx-auto grid h-10 w-10 place-items-center rounded-full border border-white/[0.12] light:border-black/10 bg-zinc-900/70 light:bg-white/70">
        <Lock className="h-4 w-4 text-zinc-300 light:text-zinc-700" aria-hidden />
      </div>
      <h2 className="mt-4 font-display text-lg tracking-tight text-zinc-50 light:text-zinc-900">
        {t("OFFERS_LOCKED_TITLE")}
      </h2>
      <p className="mx-auto mt-2 max-w-sm text-pretty text-sm leading-relaxed text-zinc-300 light:text-zinc-700">
        {t("OFFERS_LOCKED_BODY", { city: cityLabel })}
      </p>
      <button
        type="button"
        onClick={onSignUp}
        className="mt-5 inline-flex items-center justify-center rounded-full bg-paper light:bg-ink px-5 py-2 text-sm font-semibold text-ink light:text-paper transition hover:bg-white light:hover:bg-zinc-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-300 light:focus-visible:ring-zinc-700 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950"
      >
        {t("SIGNUP_FREE_CTA")}
      </button>
    </div>
  );
}
